import { render, staticRenderFns } from "./ReserveMenu.vue?vue&type=template&id=109e738a"
import script from "./ReserveMenu.vue?vue&type=script&lang=ts"
export * from "./ReserveMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports